import React from 'react'
import { INeighborhood } from '@api/types'
import MultiSelectComponent from './MultiSelectComponent'
import api from '@api'
import { Classes } from '@blueprintjs/core'
import { HighlightedText } from '..'
import css from './multiSelect.module.scss'

import { ItemProps } from './GenericSelectWithInfiniteScroll'

interface NeighborhoodSelectProps {
  values: INeighborhood[] | undefined
  onChange: (items: INeighborhood[] | undefined, deletedItem: any) => void
  onClear: () => void
  onCreate: (item: string) => Promise<INeighborhood>
}

export function NeighborHoodItem({ type, data, refItem, query }: ItemProps<INeighborhood>) {
  if (type === 'skeleton') {
    return (
      <div className="flex items-center py-1" style={{ minWidth: 300 }}>
        <div className="ml-2">
          <span className={Classes.SKELETON}>tag name</span>
        </div>
      </div>
    )
  }

  const { name } = data as INeighborhood

  return (
    <div ref={refItem} className="flex items-center py-1 truncate">
      <div className="ml-2 font-medium truncate">
        <HighlightedText query={query} text={name} />
      </div>
    </div>
  )
}

export default function NeighborhoodSelect({
  values,
  onChange,

  onCreate,
}: NeighborhoodSelectProps) {
  return (
    <MultiSelectComponent
      title=""
      customClass={{ multiCustomClass: css.multiSelectCustomClass }}
      multi={false}
      values={values || []}
      list={api.neighborhood.list}
      icon={null}
      itemRenderer={NeighborHoodItem}
      onChange={onChange}
      canCreate
      onCreate={onCreate}
    />
  )
}
